/**
 * getSessionAreaName
 *
 * Returns the current session area name.
 *
 * Non-hook imperative accessor for use outside React components.
 * Reads from Redux state (hydrated from persisted localStorage on startup).
 */
import { getStore } from '@/store/store-proxy';
import { selectAreaName } from '@/store/slices/sessionSlice';
export const getSessionAreaName = () => {
    const state = getStore().getState();
    return selectAreaName(state);
};
